import { config } from '@fortawesome/fontawesome-svg-core';
import { enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { TrackJS } from 'trackjs';
import packageJson from '../package.json';
import { AppComponent } from './app/app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ConfirmationService, MessageService as PrimeNgMessageService } from 'primeng/api';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { AuraCustom } from 'src/primeNG-themes/aura-custom';
import { providePrimeNG } from 'primeng/config';
import { BooleanifyPipe } from './app/classes/_pipes/booleanify.pipe';
import { TrackJsHttpInterceptor } from './app/classes/_interceptors/track-js.interceptor';
import { TrackJsErrorHandler } from './app/classes/_handlers/track-js-error.handler';
import { InterceptorService } from './app/classes/_services/interceptor.service';
import {
  buildTrackJsInstallOptions,
  setTrackJsEnvironmentMetadata
} from './app/classes/_utils/track-js.utils';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import 'hammerjs';
import { RouteReuseStrategy } from '@angular/router';
import { LiveAlertsRouteStrategy } from '@app/classes/_strategies/live-alerts-route-reuse.strategy';

config.autoAddCss = false;

if (environment.production) {
  enableProdMode();
}

const trackJsOptions = buildTrackJsInstallOptions(
  environment.trackJs,
  environment.customerIdentifier,
  packageJson.version
);

if (trackJsOptions) {
  TrackJS.install(trackJsOptions);
  setTrackJsEnvironmentMetadata(
    environment.customerIdentifier,
    environment.production,
    packageJson.version
  );
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, AppRoutingModule, FormsModule, ReactiveFormsModule),
    {
      provide: APP_BASE_HREF,
      useValue: '/'
    },
    {
      provide: ErrorHandler,
      useClass: TrackJsErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TrackJsHttpInterceptor,
      multi: true
    },
    {
      provide: RouteReuseStrategy,
      useClass: LiveAlertsRouteStrategy
    },
    provideHttpClient(withInterceptorsFromDi()),
    BooleanifyPipe,
    providePrimeNG({
      theme: {
        preset: AuraCustom,
        options: {
          darkModeSelector: false
        }
      }
    }),
    ConfirmPopupModule,
    ConfirmationService,
    PrimeNgMessageService,
    provideAnimations()
  ]
}).catch(err => {
  if (trackJsOptions) {
    TrackJS.track(err);
  }
  console.error(err);
});
